export default __webpack_public_path__ + "static/media/11_1.46ecf378.jpg";